<template>
  <div id="app" :class="{ 'dark': isDarkMode }">
    <router-view />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const isDarkMode = computed(() => store.getters.isDarkMode)

onMounted(() => {
  // Initialize theme from localStorage
  store.dispatch('setTheme', store.state.theme)
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background: #ffffff;
  min-height: 100vh;
  transition: background-color 0.3s ease;
}

body.dark {
  background: #111827;
}

#app {
  width: 100%;
}

/* Smooth scrolling for all browsers */
html {
  scroll-behavior: smooth;
}

/* Improve text rendering */
body, input, textarea, button {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Focus styles for accessibility */
*:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Hide focus outline when using mouse */
.js-focus-visible *:focus:not(.focus-visible) {
  outline: none;
}
</style> 